import { Button } from "@mui/material";
import { type FacilityUser } from "@src/appV2/ExperimentalHomeHealth/lib/types";
import { useIsAdmin } from "@src/appV2/ExperimentalHomeHealth/lib/useIsAdmin";
import { useModalState } from "@src/lib/ui-react";

import { FacilityUserInternalNotesDialog } from "./Dialog";

interface FacilityUserInternalNotesButtonProps {
  facilityUser: FacilityUser;
  workplaceId: string;
}

export function FacilityUserInternalNotesButton(props: FacilityUserInternalNotesButtonProps) {
  const { facilityUser, workplaceId } = props;
  const modalState = useModalState();
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <Button sx={{ paddingX: 0 }} onClick={modalState.openModal}>
        Internal Notes
      </Button>
      {modalState.modalIsOpen && (
        <FacilityUserInternalNotesDialog
          modalState={modalState}
          facilityUser={facilityUser}
          workplaceId={workplaceId}
        />
      )}
    </>
  );
}
